import { createSlice } from '@reduxjs/toolkit';

export const webcallSlice = createSlice({
    name: 'webcall',
    initialState: {},
    reducers: {}
});


// Action creators are generated for each case reducer function
export const { _ } = webcallSlice.actions;